<template>
  <div class="FilterList">
    <div
      v-if="showLabel || showDelete"
      class="flex justify-space-between title-container mb-md"
    >
      <h4
        v-if="showLabel"
        class="title intro-text"
      >
        {{ filter?.label }}
      </h4>
      <button
        v-if="showDelete && hasActiveFilters(filter)"
        class="filter-delete m-0 flex align-center flex-gap-8 flex-nowrap"
        @click="emit('delete-filter', filter)"
      >
        <UIIconComponent icon="close" />
        {{ hasActiveFilters(filter) ? 'Verwijder filter' : '' }}
      </button>
    </div>

    <div class="options">
      <UIInputCheckbox
        v-for="(option, index) in filter.options"
        :id="filter.value + option.id"
        :key="option.id"
        class="checkbox-item"
        :checked="option.isSelected"
        :disabled="option.count == 0"
        :value="option.label"
        :label="option.label"
        :class="{ 'is-hidden': index >= maxItems && !showAllItems }"
        @change="emit('update-filter', filter, option)"
      />
    </div>
    <button
      v-if="hasMaxItems"
      class="btn btn-link mt-sm"
      @click="showAllItems = !showAllItems"
    >
      {{ showAllItems ? 'Toon minder' : 'Toon meer' }}
    </button>
  </div>
</template>

<script setup lang="ts">
  import type { FilterOption } from '@tc8l/nuxt-overview'

  const props = defineProps({
    filter: {
      type: Object as PropType<FilterOption>,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    maxItems: {
      type: Number,
      default: 0,
    },
  })

  const emit = defineEmits<{
    (e: 'update-filter', filterValue: any, optionLabel: any): void
    (e: 'delete-filter', filter: FilterOption): void
  }>()

  const { hasActiveFilters } = useFilterHelpers()

  const showAllItems = ref(false)
  const hasMaxItems = computed(() => props.maxItems > 0 && props.filter.options.length > props.maxItems)
  const maxItems = computed(() => (props.maxItems > 0 ? props.maxItems : props.filter.options.length))
</script>

<style scoped lang="scss">
  .FilterList {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .title-container {
      width: 100%;
    }

    .btn {
      padding: 0;
      width: unset;
    }

    .checkbox-item {
      &.is-hidden {
        display: none;
      }
    }
  }

  .option-list {
    display: flex;
    flex-direction: column;
    margin-top: var(--margin-md);
    gap: var(--margin-xs);
    font-size: 1.8rem;
  }

  .options {
    display: flex;
    width: 100%;
    gap: 0.8rem;
    flex-direction: column;
  }
</style>
